type RuleSurfaceTone = "live" | "partial" | "sandbox" | "readonly";

export interface RuleSurfaceRow {
	name: string;
	source: string;
	edit: string;
	effect: string;
	verify: string;
	tone?: RuleSurfaceTone;
}

interface RuleSurfaceSummaryProps {
	title?: string;
	description?: string;
	rows: RuleSurfaceRow[];
	testId?: string;
}

const TONE_CLASS: Record<RuleSurfaceTone, string> = {
	live: "border-brand-success/30 bg-brand-success/10 text-brand-success",
	partial: "border-brand-warning/30 bg-brand-warning/10 text-brand-warning",
	sandbox: "border-brand-info/30 bg-brand-info/10 text-brand-info",
	readonly: "border-surface-border bg-surface-subtle text-text-secondary",
};

export function RuleSurfaceSummary({
	title = "规则与生效关系",
	description = "先确认这里管什么、能不能改、改完是否进入主链路，再决定用哪个测试入口验证。",
	rows,
	testId = "rule-surface-summary",
}: RuleSurfaceSummaryProps) {
	return (
		<section
			className="rounded-md border border-surface-border bg-surface-card"
			data-testid={testId}
		>
			<div className="border-b border-surface-border px-4 py-3">
				<h3 className="text-sm font-semibold text-text-primary">{title}</h3>
				{description ? <p className="mt-1 text-sm text-text-secondary">{description}</p> : null}
			</div>
			<div className="overflow-x-auto">
				<table className="w-full min-w-[860px] border-collapse text-sm">
					<thead className="bg-surface-subtle text-left text-xs text-text-muted">
						<tr>
							<th className="px-3 py-2 font-medium">内容</th>
							<th className="px-3 py-2 font-medium">规则来源</th>
							<th className="px-3 py-2 font-medium">是否可改</th>
							<th className="px-3 py-2 font-medium">是否生效</th>
							<th className="px-3 py-2 font-medium">验证方式</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((row) => (
							<tr key={row.name} className="border-t border-surface-border align-top">
								<td className="whitespace-nowrap px-3 py-3 font-medium text-text-primary">
									{row.name}
								</td>
								<td className="px-3 py-3 text-text-secondary">{row.source}</td>
								<td className="px-3 py-3 text-text-secondary">{row.edit}</td>
								<td className="px-3 py-3">
									<span
										className={`inline-flex rounded-md border px-2 py-1 text-xs font-medium ${
											TONE_CLASS[row.tone ?? "readonly"]
										}`}
									>
										{row.effect}
									</span>
								</td>
								<td className="px-3 py-3 text-text-secondary">{row.verify}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</section>
	);
}
